module.exports = __webpack_public_path__ + "img/Frame-journal.a42c0e07.svg";